import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import HubIcon from '@mui/icons-material/Hub';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';

// Free live workshops shown at /workshops. Edit this list to add, remove or
// reschedule workshops.
//
// date: 'YYYY-MM-DD' once scheduled, or null to show "Date announced soon".
// time: e.g. '7:00 – 9:00 PM IST', or null.
// Past dates are hidden automatically. Registrations are saved as live class
// requests with the course set to "Workshop: <title>", so they appear in the
// admin dashboard.

export const workshops = [
  {
    id: 'ai-coding-tools',
    title: 'Build software with AI coding tools',
    tagline: 'Go from idea to working feature with an AI pair programmer.',
    level: 'Beginner friendly',
    duration: '2 hours',
    date: null,
    time: null,
    icon: AutoAwesomeIcon,
    accent: ['#a855f7', '#22d3ee'],
    learn: [
      'Plan, generate and refactor code with AI assistants',
      'Review AI output and catch its mistakes',
      'Build and run a small feature live'
    ]
  },
  {
    id: 'first-ai-agent',
    title: 'Build your first AI agent',
    tagline: 'An LLM app that uses tools and answers from your own data.',
    level: 'Intermediate',
    duration: '2.5 hours',
    date: null,
    time: null,
    icon: SmartToyIcon,
    accent: ['#f472b6', '#a855f7'],
    learn: [
      'How tool use and function calling work',
      'Add retrieval (RAG) over your own documents',
      'Make it reliable: validation, limits and evaluation'
    ]
  },
  {
    id: 'dsa-patterns',
    title: 'Crack DSA patterns: two pointers and sliding window',
    tagline: 'Stop memorising problems; learn to spot the pattern.',
    level: 'All levels',
    duration: '2 hours',
    date: null,
    time: null,
    icon: AccountTreeIcon,
    accent: ['#4ade80', '#14b8a6'],
    learn: [
      'Recognise when a pattern applies',
      'Solve classic interview problems step by step',
      'Explain your approach and complexity out loud'
    ]
  },
  {
    id: 'system-design-live',
    title: 'System design live: design a URL shortener',
    tagline: 'Walk through a full design round, the way interviewers expect.',
    level: 'Intermediate',
    duration: '2 hours',
    date: null,
    time: null,
    icon: HubIcon,
    accent: ['#60a5fa', '#6366f1'],
    learn: [
      'Clarify requirements and estimate scale',
      'Design the API, data model and caching',
      'Discuss trade-offs and failure modes'
    ]
  },
  {
    id: 'react-machine-coding',
    title: 'React machine coding round, live',
    tagline: 'Build an interview-style feature in 60 minutes, with commentary.',
    level: 'Intermediate',
    duration: '2 hours',
    date: null,
    time: null,
    icon: DashboardCustomizeIcon,
    accent: ['#22d3ee', '#6366f1'],
    learn: [
      'Break down requirements before coding',
      'Structure components and state cleanly',
      'Handle edge cases, accessibility and loading states'
    ]
  },
  {
    id: 'project-story',
    title: 'Resume and interview workshop: tell your project story',
    tagline: 'Turn your projects into answers that get you to the next round.',
    level: 'All levels',
    duration: '1.5 hours',
    date: null,
    time: null,
    icon: RecordVoiceOverIcon,
    accent: ['#fbbf24', '#f472b6'],
    learn: [
      'Write resume points recruiters actually read',
      'Explain a project with impact and trade-offs',
      'Answer “tell me about yourself” with confidence'
    ]
  }
];

const today = () => new Date().toISOString().slice(0, 10);

// Scheduled workshops first (soonest first), then unscheduled ones; past ones hidden
export const upcomingWorkshops = () =>
  workshops
    .filter((w) => !w.date || w.date >= today())
    .sort((a, b) => {
      if (a.date && b.date) return a.date.localeCompare(b.date);
      if (a.date) return -1;
      if (b.date) return 1;
      return 0;
    });
